
import React from 'react';
import { Title as MantineTitle } from '@mantine/core';

interface TitleComponentProps {
  title: string;
}

const TitleComponent: React.FC<TitleComponentProps> = ({ title }) => {
  return (
    <MantineTitle order={2} className="text-secondary-text-color font-semibold text-2xl text-center">
      {title}
    </MantineTitle>
  );
};

export default TitleComponent;
